import React, {useState} from 'react';
import _ from 'lodash';
import localeText from '@locale';
import Header from '~/components/MobileHeader/index';
import Banner from '~/components/MobileBanner/index';
import Content from './Content';
import NotFound from '~/components/404';
import {getTutorialConfig} from '~/utils/tools';
import BannerBg from '~/assets/images/tutorial/banner/banner_bg_tutorials_mobile.png';
import './index.less';

const TutorialMobile = ({history, match}) => {
  const {
    params: {locale, version}
  } = match;
  const [menuOpen, setMenuOpen] = useState(false);
  const tutorialConfig = getTutorialConfig(locale);

  const versionKeys = Object.keys(tutorialConfig).sort((p, n) => tutorialConfig[p].order - tutorialConfig[n].order);
  if (_.indexOf(versionKeys, version) === -1) {
    return <NotFound />;
  }

  return (
    <div className='tutorial-mobile'>
      <Header
        locale={locale}
        version={version}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        isTutorial
        configData={tutorialConfig?.[version]?.header || []}
        versionKeys={versionKeys}
        history={history}
      />
      <Banner
        bannerBg={BannerBg}
        title={localeText('COMMON.TXT_TUTORIAL_TITLE')}
        description={localeText('COMMON.TXT_TUTORIAL_DESCRIPTION')}
      />
      <Content configData={tutorialConfig?.[version]?.content || []} />
      <div className='copy-right'>{localeText('COMMON.TXT_COPY_RIGHT', new Date().getFullYear())}</div>
    </div>
  );
};

export default TutorialMobile;
